<template>

</template>


<script>


export default {
  data() {
    return {
      isMore: false,
      isRegister: false,
      isLogin: false,
      showPlistTips: false,
      showWXTips: false,
      mRunRomSystem: "android",
      chData: '',
      defaultData: "MjYzNzE1OQ",
    }
  },
  created() {

  },
  methods: {

  }
};
</script>


<style scoped lang='less'>
@import "../../assets/css/home/index.less";
</style>


<style scoped lang='less'>
.plist-container {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
  overflow: auto;
}

.plist-container img {
  width: 100%;
}

.wx_flow_img {
  position: absolute;
  top: 0px;
  left: 0;
}
</style>

<style scoped lang='less'>
.wx-tips-div {
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #fff;
}

.wx-tips-div img {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// index.vue?3b212fe4